import type { ButtonHTMLAttributes, CSSProperties } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { MissionRow, type MissionRowProps } from './MissionRow';

export interface SortableMissionRowProps extends MissionRowProps {
  readonly id: string;
}

/** Enveloppe `MissionRow` d'un comportement `@dnd-kit` glisser-déposer pendant la réorganisation. */
export function SortableMissionRow({ id, ...rowProps }: SortableMissionRowProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });
  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 2 : undefined,
  };
  const dragHandleProps = { ...attributes, ...listeners } as ButtonHTMLAttributes<HTMLButtonElement>;

  return (
    <div ref={setNodeRef} style={style}>
      <MissionRow {...rowProps} dragHandleProps={dragHandleProps} />
    </div>
  );
}
